import { Card, Image, List, Menu } from "antd";
import React, { Component } from "react";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../withRouter";

class ReportsMenus extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      showMenu: false,
      showMenu1: true,

      items: [],
      remaining: [],
    };
    this.handleMenuClick = this.handleMenuClick.bind(this);
  }

  toggleMenu = () => {
    this.setState({ showMenu1: false });
  };

  handleMenuClick = (items) => {
    this.props.navigate("/" + items);
    this.props.closeMenu();
  };

  async componentDidMount() {
    const items = [
      {
        key: "info",
        type: "group",
        label: (
          <div
            style={{
              padding: "15px",
              color: "#fff",
              backgroundColor: "#002766",
            }}
          >
            <span
              className="menu-items-title"
              style={{
                gap: 14,
              }}
            >
              <img
                src={require("../assets/images/NewDesign/clipboard-filll.png")}
                alt="Masters"
                style={{ width: "22px" }}
              />
              {this.context.translate("_FLEET_REPORTS_TAB_")}
            </span>

            <p
              style={{
                fontSize: "10px",
                marginTop: "5px",
                color: "rgba(255, 255, 255, 0.8)",

                marginBottom: "0px",
              }}
            >
              {this.context.translate("_REPORTS_DESC_")}
            </p>
          </div>
        ),
      },
    ];

    const remaining = [
      this.props.trackingReport.length > 0 && {
        key: "parenttrackingreport",
        type: "parenttrackingreport",
        label: (
          <div onClick={this.toggleMenu}>
            <span
              className="submenu-items-title"
              style={{ gap: 10 }}
              // style={{
              //   color: "#07163D",
              //   display: "flex",
              //   alignItems: "center",
              //   gap: 14,
              //   margin: 0,
              // }}
            >
              <Image
                src={require("../assets/images/NewDesign/Reports/clipboard-data-fill.png")}
                // alt="Masters"
                style={{ width: "16px" }}
              />
              {this.context.translate("_TRACKING_REPORT_")}
            </span>
            {this.state.showMenu1 && (
              <p
                className="submenu-items-desc"
                // style={{
                //   fontSize: "10px",
                //   marginTop: "10px",
                //   color: "rgba(0, 0, 0, 0.8)",
                //   marginBottom: "0px",
                //   textWrap: "auto",
                //   lineHeight: "normal",
                // }}
              >
                {this.context.translate("_TRACKING_REPORTS_DESC_")}
              </p>
            )}
          </div>
        ),
        children: this.props.trackingReport,
      },
      this.props.miscellaneousReport.length > 0 && {
        key: "parentmiscellaneousreport",
        type: "parentmiscellaneousreport",
        label: (
          <div onClick={this.toggleMenu}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Reports/clipboard-x-fill.png")}
                // alt="Masters"
                style={{ width: "16px" }}
              />
              {this.context.translate("_MISCELLANEOUS_REPORTS_")}
            </span>
            {this.state.showMenu1 && (
              <p
                // style={{
                //   fontSize: "10px",
                //   marginTop: "10px",
                //   color: "rgba(0, 0, 0, 0.8)",
                //   marginBottom: "0px",
                //   textWrap: "auto",
                //   lineHeight: "normal",
                // }}
                className="submenu-items-desc"
              >
                {this.context.translate("_MISCELLANEOUS_REPORTS_DESC_")}
              </p>
            )}
          </div>
        ),
        children: this.props.miscellaneousReport,
      },
      this.props.driverReport.length > 0 && {
        key: "parentdriverreport",
        type: "parentdriverreport",
        label: (
          <div onClick={this.toggleMenu}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Reports/clipboard-plus-fill.png")}
                // alt="Masters"
                style={{ width: "16px" }}
              />
              {this.context.translate("_DRIVER_RELATED_")}
            </span>
            {this.state.showMenu1 && (
              <p
                // style={{
                //   fontSize: "10px",
                //   marginTop: "10px",
                //   color: "rgba(0, 0, 0, 0.8)",
                //   marginBottom: "0px",
                //   textWrap: "auto",
                //   lineHeight: "normal",
                // }}
                className="submenu-items-desc"
              >
                {this.context.translate("_DRIVER_RELATED_REPORTS_DESC_")}
              </p>
            )}
          </div>
        ),
        children: this.props.driverReport,
      },
      this.props.fleetReport.length > 0 && {
        key: "parentfleetreport",
        type: "parentfleetreport",
        label: (
          <div onClick={this.toggleMenu}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Reports/clipboard-minus-fill.png")}
                // alt="Masters"
                style={{ width: "16px" }}
              />
              {this.context.translate("_FLEET_REPORT_")}
            </span>
            {this.state.showMenu1 && (
              <p
                // style={{
                //   fontSize: "10px",
                //   marginTop: "10px",
                //   color: "rgba(0, 0, 0, 0.8)",
                //   marginBottom: "0px",
                //   textWrap: "auto",
                //   lineHeight: "normal",
                // }}
                className="submenu-items-desc"
              >
                {this.context.translate("_FLEET_REPORT_DESC_")}
              </p>
            )}
          </div>
        ),
        children: this.props.fleetReport,
      },
      this.props.alertReport.length > 0 && {
        key: "parentalertreport",
        type: "parentalertreport",
        label: (
          <div onClick={this.toggleMenu}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Reports/clipboard-x-fill-1.png")}
                // alt="Masters"
                style={{ width: "16px" }}
              />
              {this.context.translate("_ALERT_REPORT_")}
            </span>
            {this.state.showMenu1 && (
              <p
                // style={{
                //   fontSize: "10px",
                //   marginTop: "10px",
                //   color: "rgba(0, 0, 0, 0.8)",
                //   marginBottom: "0px",
                //   textWrap: "auto",
                //   lineHeight: "normal",
                // }}
                className="submenu-items-desc"
              >
                {this.context.translate("_ALERT_REPORT_DESC_")}
              </p>
            )}
          </div>
        ),
        children: this.props.alertReport,
      },
      this.props.adminReport.length > 0 && {
        key: "parentadminreport",
        type: "parentadminreport",
        label: (
          <div onClick={this.toggleMenu}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Reports/clipboard-check-fill.png")}
                // alt="Masters"
                style={{ width: "16px" }}
              />
              {this.context.translate("_ADMIN_REPORT_")}
            </span>
            {this.state.showMenu1 && (
              <p
                // style={{
                //   fontSize: "10px",
                //   marginTop: "10px",
                //   color: "rgba(0, 0, 0, 0.8)",
                //   marginBottom: "0px",
                //   textWrap: "auto",
                //   lineHeight: "normal",
                // }}
                className="submenu-items-desc"
              >
                {this.context.translate("_ADMIN_REPORT_DESC_")}
              </p>
            )}
          </div>
        ),
        children: this.props.adminReport,
      },
      // this.props.bookingReport.length > 0 && {
      //   key: "parentbookingreport",
      //   type: "parentbookingreport",
      //   label: (
      //     <div onClick={this.toggleMenu}>
      //       <span className="submenu-items-title" style={{ gap: 10 }}>
      //         <Image
      //           src={require("../assets/images/NewDesign/Reports/clipboard-check-fill.png")}
      //           // alt="Masters"
      //           style={{ width: "16px" }}
      //         />
      //         {this.context.translate("_BOOKING_REPORT_")}
      //       </span>
      //       {this.state.showMenu1 && (
      //         <p

      //           className="submenu-items-desc"
      //         >
      //           {this.context.translate("_BOOKING_REPORT_DESC_")}
      //         </p>
      //       )}
      //     </div>
      //   ),
      //   children: this.props.bookingReport,
      // }
    ];

    this.setState({ items: items, remaining: remaining });
  }
  render() {
    return (
      <div className="menu-items-card">
        <div className="menu-items-list">
          <Menu
            style={{
              // height: "90vh",
              border: "none",
              scrollbarWidth: "none",
              overflow: "scroll",
              // boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
            }}
            items={this.state.items}
          />
        </div>
        <div
          className="submenu-items-list"
          // style={{
          //   overflow: "scroll",
          //   boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
          //   height: "70vh",
          //   scrollbarWidth: "none",
          // }}
        >
          <Menu
            style={{
              height: "90vh",
              border: "none",
              scrollbarWidth: "none",
              overflow: "scroll",
              boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
              alignContent: "flex-start",
              height: "100%",
            }}
            mode="inline"
            items={this.state.remaining}
            onClick={(items) => this.handleMenuClick(items.key)}
            onMouseLeave={() => this.props.closeMenu()}
          />
        </div>
      </div>
    );
  }
}
ReportsMenus.contextType = StoreContext;
export default observer(withRouter(ReportsMenus));
